  <template>
  <v-dialog v-model="modal" persistent width="800px">
    <v-card>
      <v-card-title>Suppression de l'annexe</v-card-title>
      <v-card-text>
        Voulez vous supprimer l'annexe suivante {{ document?.nom }} ?
      </v-card-text>
      <v-card-actions>
        <v-btn data-testid="valider-supprimer-document" color="primary" @click="valide" :loading="working"> Oui </v-btn>
        <v-btn data-testid="annuler-supprimer-document" ref="non" @click="ferme" :disabled="working"> Non </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import makeRemoteWorker from "@/mixins/makeRemoteWorker";
import { piecesService } from "@/services";

export default {
  mixins: [makeRemoteWorker()],

  data() {
    return {
      document: null,
      modal: false,
    };
  },

  methods: {
    ferme() {
      this.modal = false;
    },
    supprime({ document }, next) {
      this.document = document;
      this.modal = true;
      this.callback = next;
    },
    valide() {
      this.doWork({
        forms: [],
        work() {
          return piecesService.supprimeDocumentPiece(this.document.lien);
        },
        callback(valeur) {
          this.callback(valeur);
          this.ferme();
        },
        successText: "L'annexe a été supprimée.",
        errorText: "Erreur durant la suppression de l'annexe.",
      });
    },
  },
};
</script>
